export const DOMAIN_GIFT = 'HQ10DOMAINGIFT';
export const FREE_TRIAL = 'freetrial';
export const GIFT = 'gift';
export const CLOUDTEST$1 = 'CLOUDTEST$1';
